module.exports = __webpack_public_path__ + "img/kuang_right_chang.f52184cb.png";